import axiosInstance from '../../../../config/axiosInstance';
const  CustomerAccountnTypeService = {
    async GetAllCustomerAccountnType(redirectCallback) {
        try {           
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetCustomerAccountType`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    
};

export default CustomerAccountnTypeService;